var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgYoutube = function SvgYoutube(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.627 12.35c.402.409.688.915.829 1.468.375 2.047.557 4.125.543 6.205a33.28 33.28 0 0 1-.543 6.113 3.224 3.224 0 0 1-.83 1.468 3.294 3.294 0 0 1-1.463.86C28.131 29 20 29 20 29s-8.13 0-10.163-.536a3.297 3.297 0 0 1-1.444-.821 3.227 3.227 0 0 1-.849-1.414 33.28 33.28 0 0 1-.543-6.206c-.01-2.065.171-4.127.543-6.159.14-.552.427-1.059.83-1.468a3.294 3.294 0 0 1 1.463-.86C11.87 11 20 11 20 11s8.13 0 10.163.489a3.295 3.295 0 0 1 1.464.86Zm-7.824 6.754-5.126-3.247c-.521-.33-.782-.496-.998-.48a.652.652 0 0 0-.474.255c-.13.17-.13.476-.13 1.087v6.493c0 .611 0 .917.13 1.087a.653.653 0 0 0 .474.256c.216.015.477-.15.998-.481l5.126-3.247c.453-.286.68-.43.758-.612a.631.631 0 0 0 0-.499c-.079-.182-.305-.326-.758-.612Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYoutube);
export default ForwardRef;